<template>
  <div class="sign">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="list">
      <van-row type="flex" justify="center" align="center">
        <van-col span="4">库位</van-col>
        <van-col span="12">托唛</van-col>
        <van-col span="4">在库数</van-col>
        <van-col span="4">盘点数</van-col>
      </van-row>
      <div>
        <van-swipe-cell v-for="(item, index) in list" :key="index">
          <div class="list-div">
            <p class="listP1">{{ item.storage }}</p>
            <p class="listP2">{{ item.scanCode }}</p>
            <p class="listP1">{{ item.inStockBoxCount }}</p>
            <p class="listP1">{{ item.boxCount }}</p>
          </div>
        </van-swipe-cell>
      </div>
      <div class="submit-box">
        <p>
          <van-field
            size="small"
            v-model="scanLocationCode"
            placeholder="请扫描或输入库位"
            right-icon="scan"
            @click-right-icon="scanStorage"
            ref="storage"
            @keyup.13="nextText(1)"
          />
        </p>
        <p>
          <van-field
            size="small"
            v-model="scanCodePallet"
            placeholder="请扫描或输入托唛"
            right-icon="scan"
            clear-trigger="always"
            clearable
            @click-right-icon="scanPallet"
            @keyup.13="nextText(2)"
            ref="scanCodePallet"
          />
        </p>
        <p>
          <van-field
            size="small"
            v-model="boxCount"
            placeholder="请输入盘点箱数"
            clear-trigger="always"
            clearable
            @keyup="inputNum"
            ref="boxCount"
          />
        </p>
        <button class="submit-btn" @click="submit">保存</button>
      </div>
    </div>

    <van-dialog
      v-model="show"
      :title="`库位 ${saveLocationCode}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirm"
    >
      <div style="padding: 5% 20%">
        <van-field
          type="digit"
          size="small"
          placeholder="请输入移库箱数"
          v-model="saveNum"
        />
      </div>
    </van-dialog>

    <van-popup v-model="showPicker" round position="bottom" :overlay="false">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :loading="loading"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  saveInventoryInfo,
  getInventoryInfo,
} from "@/api/mobile/jy-inventoryInfo_api";
import { getWarehouseLocation } from "@/api/mobile/stock_api";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      list: [],
      scanLocationCode: "",
      scanCode: "",
      scanCodePallet: "",
      boxCount:"",
      show: false,
      saveLocationCode: "",
      saveNum: "",
      refuseReason: "",
      showErrStr: "",
      isAutoOpen: false,
      successStr: "",
      scanskuStorageCommon: {},
      newskuStorageCommonList: [],
      countchangeNum: 0,
      totle: 0,
      showPicker: false,
      columns: [],
      loading: false,
      focusType: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),

    init() {
      this.saveMobileTitle(window.localStorage.mobileTitle);
    },
    onConfirm(val) {
      this.scanLocationCode = val;
      this.showPicker = false;
    },
    nextText(type){
        if(type==1)
        {
          this.$refs.scanCodePallet.focus();
        }
        if(type==2)
        {
          this.$refs.boxCount.focus();
        }
    },
    getList() {
      this.showErrStr = "";
      this.successStr = "";
      var isSuccess = true;
      const data = {
      };
      Toast.loading({
        message: "查询中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      getInventoryInfo(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
            this.list = res.response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    openModel(code) {
      this.show = !this.show;
      this.saveLocationCode = code;
      this.isAutoOpen = false;
      this.successStr = "";
    },

    confirm() {
      this.list.forEach((item, i) => {
        if (item.storages === this.saveLocationCode) {
          if (this.saveNum > item.totalQty) {
            Toast("转化数不可大于库存数");
            this.saveNum = 0;
          }
          this.$set(this.list[i], "changeNum", this.saveNum || 0);
        }
      });
      const s = this.saveNum;
      if (this.isAutoOpen) {
        this.showErrStr = "";
        this.successStr = `库位 ${this.saveLocationCode} 扫入成功，数量${s}`;
      }
      this.saveNum = "";

      var arr2 = [];
      this.list.forEach((item, index) => {
        if (item.changeNum) {
          arr2.push(item.changeNum);
        }
      });
      this.countchangeNum = arr2.reduce(
        (prev, cur) => Number(prev) + Number(cur)
      );
    },

    toDelete(i) {
      this.countchangeNum = this.countchangeNum - this.list[i].changeNum;
      this.$set(this.list[i], "changeNum", 0);
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      if (this.scanLocationCode == "") {
        this.showsound(false);
        Toast.fail("请输入库位");
          this.$refs.storage.focus();
        return;
      }
      if (this.scanCodePallet == "") {
        this.showsound(false);
        Toast.fail("请输入托唛号");
          this.$refs.scanCodePallet.focus();
        return;
      }
      if (this.boxCount == "") {
        this.showsound(false);
        Toast.fail("请输入盘点箱数");
        this.$refs.boxCount.focus();
        return;
      }
      const data = {
        Storage: this.scanLocationCode,
        ScanCode: this.scanCodePallet,
        BoxCount:this.boxCount
      };
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      saveInventoryInfo(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.successStr = "";
          this.showErrStr = "";
          Toast.success(res.msg);
          this.getList();
          this.scanCodePallet='';
          this.scanLocationCode='';
          this.boxCount ='';
          this.$refs.storage.focus();
          
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    scanDocCode() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanCode = a.resultStr;
          that.getList();
        },
      });
    },
    scanPallet() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanCodePallet = a.resultStr;
        },
      });
    },
    scanStorage() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanLocationCode = a.resultStr;
        },
      });
    },
  },
};
</script>

<style>
.van-picker__confirm,
.van-picker__cancel {
  font-size: 20px;
}
</style>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        white-space: nowrap;
        word-break: break-all;
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            width: 50%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}

.submit-box {
  position: static;
  margin: 10px 0;
  > p {
    max-width: 95%;
    margin: 0 auto;
  }
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  position: static;
  bottom: 2%;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}

.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
  .van-cell {
    margin-bottom: 0;
  }
  .btn-box {
    flex: 1;
  }
  .toSearch-box {
    margin-left: 3%;
    min-height: inherit;
  }
  .sign-toSearch {
    height: 100%;
    width: 100%;
  }
}

.sign-toSearch {
  width: 50%;
  height: 45%;
  min-height: 10px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 15px;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.list {
  .list-div {
    display: flex;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
  .listP1 {
    width: 20%;
  }
  .listP2 {
    width: 60%;
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
</style>